import React, { useState } from 'react';
import ViewFilterButton from '../../../../../components/ProTable/ViewFilterButton';
import { useSelector } from 'react-redux';
import { getFilter } from '../../../../../stores/algos-list/getters';
import { updateFilter } from '../../../../../stores/algos-list/actions';
import ViewFilterModalDecorated from '../../../../../components/ProTable/ViewFilterModalDecorated';

const options = [
  {
    label: 'No Errors',
    value: null,
  },
  {
    label: 'Account/Broker disabled',
    value: 'disabledBroker',
  },
  {
    label: 'Error in one or more positions',
    value: 'hasError',
  },
  {
    label: 'Waiting',
    value: 'hasWaitingWT',
  },
  {
    label: 'Old trailing SL setting',
    value: 'stoplossTrailing',
  },
];

const ViewAlerts = () => {
  const [open, setOpen] = useState(false);
  const viewsFilter = useSelector((state) => {
    const { views = {} } = getFilter(state);
    return views;
  });
  const isViewActive = viewsFilter.alerts ? true : false;

  function onOpen() {
    setOpen(true);
  }

  function onClose() {
    setOpen(false);
  }

  return (
    <>
      <ViewFilterButton onClick={onOpen} isActive={isViewActive} />
      {open ? (
        <ViewFilterModalDecorated
          open={open}
          onClose={onClose}
          updateFilter={updateFilter}
          options={options}
          viewsFilter={viewsFilter}
          fieldName="alerts"
          title="Filter Alerts:"
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ViewAlerts;
